<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
        v-if="captivePortal"
        :items="captivePortal"
        :fields="captivePortalFields"
        @ClickOnDeleteButton="ClickOnDeleteButton"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isDelete="true"
        isEdit="true"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <editModal :editItem="selectedCaptivePortal"
    :tariffs="tariffs"
    :groups="groups"
    :accountingPeriods="accountingPeriods"/>
  </div>
</template>

<script>
import editModal from './editModal'
export default {
  components: {
    editModal
  },
  data () {
    return {
      captivePortalFields: [
        {key: 'cp_utariff_data_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'tariff_id',
          label: this.$i18n.t('Tariff'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('Disabled') + '(0)'
            }
            for (let el of this.tariffs) {
              if (val === el.value) {
                return el.text + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'accounting_period_id',
          label: this.$i18n.t('Accounting period'),
          sortable: true,
          formatter: (val, key, item) => {
            for (let el of this.accountingPeriods) {
              if (val === el.value) {
                return el.text
              }
            }
            return val
          }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedCaptivePortal: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedCaptivePortal = {
        name: '',
        cp_utariff_data_id: 0,
        group_id: 0,
        tariff_id: 0,
        is_enabled: 0,
        accounting_period_id: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditCaptivePortal', '#btnShow')
    },
    editItem (item) {
      this.selectedCaptivePortal = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditCaptivePortal', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Captive Portal"?', this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_CAPTIVE_PORTAL', item.cp_utariff_data_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_CAPTIVE_PORTAL')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    captivePortal () {
      let tmp = JSON.parse(JSON.stringify(this.$store.getters['Settings/CAPTIVE_PORTAL']))
      for (let el of tmp) {
        let color = el.is_enabled ? 'success' : 'danger'
        el._cellVariants = {cp_utariff_data_id: color}
      }
      return tmp
    },
    groups () {
      let res = []
      res.push({value: 0, text: this.$t('All')})
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      return res
    },
    tariffs () {
      let res = []
      res.push({value: 0, text: this.$t('Disabled')})
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        let isPush = true
        for (let elTariffs of el.services) {
          for (let elServices of this.$store.getters['Tariffing/SERVICES']) {
            if (elTariffs.service_id === elServices.service_id && (elServices.service_type === 3 || elServices.service_type === 5 || elServices.service_type === 6)) {
              isPush = false
            }
          }
        }
        if (isPush) {
          if (el.id === 0) {
            continue
          }
          let newEl = {}
          newEl.value = el.id
          newEl.text = el.name
          res.push(newEl)
        }
      }
      return res
    },
    accountingPeriods () {
      let res = []
      for (let el of this.$store.getters['Tariffing/ACCOUNTING_PERIODS']) {
        if (el.id === 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.id
        let accPeriodName = ''
        switch (el.periodic_type) {
          case 1:
            accPeriodName = this.$i18n.t('Daily')
            break
          case 2:
            accPeriodName = this.$i18n.t('Weekly')
            break
          case 3:
            accPeriodName = this.$i18n.t('Monthly')
            break
          case 4:
            accPeriodName = this.$i18n.t('Quarterly')
            break
          case 5:
            accPeriodName = this.$i18n.t('Annual')
            break
          default:
            accPeriodName = this.$i18n.t('CustomDuration')
            break
        }
        newEl.text = el.id + ' (' + this.$root.getMomentWithTZDelta(Number(el.begin)).format('DD-MM-YYYY') + '-' + this.$root.getMomentWithTZDelta(Number(el.end)).format('DD-MM-YYYY') + ') ' + accPeriodName
        res.push(newEl)
      }
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_CAPTIVE_PORTAL')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Tariffing/GET_TARIFFS')
    this.$store.dispatch('Tariffing/GET_ACCOUNTING_PERIODS')
    this.$store.dispatch('Tariffing/GET_SERVICES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/captivePortal/main.vue